import { StyledLoadingPlaceholder } from './styles';
import { LoadingPlaceholderProps } from './types';

export const LoadingPlaceholder = ({ height = '100%', width = '100%', className }: LoadingPlaceholderProps) => {
  return <StyledLoadingPlaceholder height={height} width={width} className={className} />;
};
